/**
 * Mutations for wordpress/media module
 */
import types from './types'

const mutations = {
  [types.FETCH]: (state, payload) => {
    state.media = payload
  },
  [types.CREATE]: (state, payload) => {
    if (!state.media.some(id => id === payload.id)) {
      state.media.unshift(payload)
    }
  },
  [types.UPDATE]: (state, payload) => {
    state.media[state.media.findIndex(item => item.id === payload.id)] = payload
  },
  [types.DELETE]: (state, payload) => {
    state.media.splice(state.media.findIndex(item => item.id === payload.id), 1)
  }
}

export default mutations



// WEBPACK FOOTER //
// ./src/store/modules/wordpress/media/mutations.js